import { Box, TextField, Typography } from '@mui/material';
import React from 'react';
import { useWatch } from 'react-hook-form';
import CustomTextInput from '../../components/CustomTextInput';

export const NOTE_MAX_LENGTH = 1000;

export const NOTE_ALLOWED_PATTERN = /^[\p{L}\p{N} \n\r]*$/u;

function formatCharacterCounter(template, count) {
  if (!template) {
    return `${count}/${NOTE_MAX_LENGTH} characters`;
  }

  return template.replace('{count}', String(count));
}

export default function DocumentNoteField({ control, errors, readOnly = false, value = '', messages = {} }) {
  const noteValue = typeof value === 'string' ? value : '';
  const watchedNote = useWatch({ control, name: 'note', defaultValue: '' });
  const currentNote = readOnly ? noteValue : typeof watchedNote === 'string' ? watchedNote : '';
  const characterCount = currentNote.length;
  const characterCounterText = formatCharacterCounter(messages.character_counter, characterCount);

  return (
    <Box sx={{ my: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography fontWeight="bold">{messages.label}</Typography>
        <Typography variant="caption" color="text.secondary" data-testid="note-character-counter">
          {characterCounterText}
        </Typography>
      </Box>
      {readOnly ? (
        <TextField
          data-testid="note"
          value={noteValue}
          variant="outlined"
          fullWidth
          multiline
          minRows={4}
          InputProps={{ readOnly: true }}
          inputProps={{ 'aria-label': messages.label }}
        />
      ) : (
        <CustomTextInput
          control={control}
          errors={errors}
          name="note"
          placeholder={messages.placeholder}
          multiline
          rows={4}
          inputProps={{ 'aria-label': messages.label, maxLength: NOTE_MAX_LENGTH }}
        />
      )}
    </Box>
  );
}
